import React from 'react';
import './ProjectSort.css';

const ProjectSort = ({ sortBy, onSortChange }) => {
  return (
    <div className="project-sort">
      <label htmlFor="sort-select">Sort by: </label>
      <select 
        id="sort-select"
        value={sortBy} 
        onChange={(e) => onSortChange(e.target.value)}
        className="sort-dropdown"
      >
        <option value="dueDate-asc">Due Date (Earliest First)</option>
        <option value="dueDate-desc">Due Date (Latest First)</option>
        <option value="createdAt-asc">Created Date (Oldest First)</option>
        <option value="createdAt-desc">Created Date (Newest First)</option>
        <option value="category">Category (A-Z)</option>
        <option value="title">Title (A-Z)</option>
      </select>
    </div>
  );
};

export default ProjectSort;